import { ColumnDataTypes, ITableColumn, TableColumn } from 'new-table-editor';
import { Serializable, StarbaseEntity } from 'starbase-launcher';
import { ColumnModel, IColumnModel } from 'table-editor';

/** LU_BattleModel */
export class Battle extends StarbaseEntity implements Serializable<Battle> {
  public name: string;
  public appears: number;

  // eslint-disable-next-line @typescript-eslint/naming-convention
  public static BattleColumnData(editable: boolean = false): IColumnModel[] { // TODO: Do we need the old table editor data still?
    return [
      new ColumnModel('UID', 'uid', 'UID', false, 'number', false, false, 10, false, null, null),
      new ColumnModel('Name', 'name', 'Name', editable, 'string', true, true, 256, false),
      new ColumnModel('Created By', 'createdByUser', 'CreatedByUser', false, 'string', false, false, 100, false),
      new ColumnModel('Created Date/Time', 'createdDateTime', 'CreatedDateTime', false, 'date', false, true, 100, false)
    ];
  }

  // eslint-disable-next-line @typescript-eslint/naming-convention
  public static BattleColumns(showUID = false, showGUID = false, showWhodunits = false): ITableColumn[] {
    const nameCol = new TableColumn('name', 'Name', ColumnDataTypes.string, true, true, true);
    nameCol.sortAsc = true;

    const appearCol = new TableColumn('appears', 'Appears', ColumnDataTypes.number, false, false);
    appearCol.textAlignment = 'center';

    return [
        nameCol,
        appearCol,
        ...TableColumn.generateColumnsForStarbaseEntity(showUID, showGUID, showWhodunits)
    ];
}

  deserialize(input: object): Battle {
    return Object.assign(new Battle(), input);
  }
}

export class BattleSelect extends StarbaseEntity implements Serializable<BattleSelect> {
  public battle: Battle;

  // eslint-disable-next-line @typescript-eslint/naming-convention
  public static BattleSelectColumnData(battles: Battle[], editable: boolean = false): IColumnModel[] {
    return [
      new ColumnModel(
        'Battle', 'battle', 'Battle', editable, 'dropdown', true, true, 50, false, battles, 'name', null, null, null, null, false)
    ];
  }

  deserialize(input: object): BattleSelect {
    return Object.assign(new BattleSelect(), input);
  }
}
